import React from 'react';
import './eyecarecareer.css';
import { Link } from 'react-router-dom';

function EyecareCareer() {
  const careerPosts = [
    {
      id: 1,
      title: "Data Entry Operator | Accounting Assistant",
      location: "Colombo 08",
      type: "Full-time",
      image: '/career1.jpg',
      salary: {
        entryLevel: "25,000 LKR (no experience)",
        experienced: "35,000+ LKR (with 12 months accounting experience)",
        negotiable: "Higher salary negotiable for taxation/auditing experience"
      },
      hours: "8:30 AM - 5:30 PM",
      address: "932 Maradana Road, Colombo 08",
      contact: {
        phone: "77 344 0937",
        email: "ecinstitute@gmail.com"
      },
      responsibilities: [
        "Accurate data entry and record keeping",
        "Assisting with basic accounting functions",
        "Maintaining financial records",
        "Supporting audit and taxation processes"
      ],
      requirements: [
        "Basic computer literacy",
        "Attention to detail",
        "12 months accounting experience for higher salary bracket",
        "Knowledge of taxation/auditing is a plus"
      ]
    },


    //   {
    //   id: 2,
    //   title: "IT Support Specialist",
    //   location: "Colombo 08",
    //   type: "Full-time",
    //   image: '/career1.jpg',
    //   salary: {
    //     entryLevel: "25,000 LKR (no experience)",
    //     experienced: "35,000+ LKR (with 12 months accounting experience)",
    //     negotiable: "Higher salary negotiable for taxation/auditing experience"
    //   },
    //   hours: "8:30 AM - 5:30 PM",
    //   address: "932 Maradana Road, Colombo 08",
    //   contact: {
    //     phone: "77 344 0937",
    //     email: "ecinstitute@gmail.com"
    //   },
    //   responsibilities: [
    //     "Accurate data entry and record keeping",
    //     "Assisting with basic accounting functions",
    //     "Maintaining financial records",
    //     "Supporting audit and taxation processes"
    //   ],
    //   requirements: [
    //     "Basic computer literacy",
    //     "Attention to detail",
    //     "12 months accounting experience for higher salary bracket",
    //     "Knowledge of taxation/auditing is a plus"
    //   ]
    // }


    
  ];

  return (
    <div className="eyecare-career-container">
      {/* Hero Section */}
      <section className="career-hero" style={{ backgroundColor: 'rgb(53, 60, 76)' }}>
        <div className="hero-content">
          <h1 className='career-heading'>Build a Rewarding Career in Eye Care</h1>
          <p className='career-para'>Join our team and contribute to quality eye care services</p>
        </div>
      </section>

      {/* Career Posts Section */}
      <section className="career-posts-section">
        <h2 className="section-title">Current Opportunities</h2>
        <div className="career-posts-grid">
          {careerPosts.map(post => (
            <div key={post.id} className="career-post-card">
              <div className="post-image-container">
                <img 
                  src={process.env.PUBLIC_URL + post.image} 
                  alt={post.title}
                  className="post-image"
                  onError={(e) => {
                    e.target.src = process.env.PUBLIC_URL + '/placeholder-career.jpg';
                  }}
                />
                <span className="post-badge">{post.type}</span>
              </div>
              
              <div className="post-content">
                <h3>{post.title}</h3>
                <p className="post-location">
                  <LocationIcon /> {post.location}
                </p>
                
                {/* Two-column layout for job details */}
                <div className="job-details-grid">
                  <div className="job-details-column">
                    <div className="detail-section">
                      <h4>Salary Information</h4>
                      <ul>
                        <li>{post.salary.entryLevel}</li>
                        <li>{post.salary.experienced}</li>
                        <li>{post.salary.negotiable}</li>
                      </ul>
                    </div>
                    
                    <div className="detail-section">
                      <h4>Working Hours</h4>
                      <p>{post.hours}</p>
                    </div>
                    
                    <div className="detail-section">
                      <h4>Location</h4>
                      <p>{post.address}</p>
                    </div>
                  </div>
                  
                  <div className="job-details-column">
                    <div className="detail-section">
                      <h4>Key Responsibilities</h4>
                      <ul>
                        {post.responsibilities.map((item, index) => (
                          <li key={index}>{item}</li>
                        ))}
                      </ul>
                    </div>
                    
                    <div className="detail-section">
                      <h4>Requirements</h4>
                      <ul>
                        {post.requirements.map((item, index) => (
                          <li key={index}>{item}</li>
                        ))}
                      </ul>
                    </div>
                    
                    <div className="detail-section">
                      <h4>Contact Information</h4>
                      <p>Phone: {post.contact.phone}</p>
                      <p>Email: <a href={`mailto:${post.contact.email}`}>{post.contact.email}</a></p>
                    </div>
                  </div>
                </div>
                
                <Link to={`/careerapply/${post.id}`} className="read-more-link">
                  <button className="apply-button">Apply Now</button>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

// SVG component for location icon
const LocationIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="#8B0000">
    <path d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2ZM12 11.5C10.62 11.5 9.5 10.38 9.5 9C9.5 7.62 10.62 6.5 12 6.5C13.38 6.5 14.5 7.62 14.5 9C14.5 10.38 13.38 11.5 12 11.5Z"/>
  </svg>
);

export default EyecareCareer;